$(function () {
	$('.simpleblogcard_wrap').before('<div class="related-article"><p>関連記事</p></div>');
});